import { Paper, Box, Avatar, Typography } from '@material-ui/core'
import { useState } from 'react'

const FacultyItem = ({classroom, onClick}) => {

  const style = {
    itemContainer: {
      border: '1px solid white',
      borderLeft: '5px solid #f37800',
      padding: '10px',
      borderRadius: '5px',
      cursor: 'pointer',
      backgroundColor: 'white',
      transition: '0.2s ease all',
      flexBasis: '300px'
    },
    detailsTitle: {
      fontWeight: 'bold'
    },
    avatar: {
      backgroundColor: '#48c8e0'
    }
  }

  const [itemElevation, setItemElevation] = useState(1)

  const avatarInitials = (name) => {
    let words = name.split(" ")
    return words.map(word => word.substr(0, 1))
  }

  return (
    <Paper
      key={classroom.faculty_id}
      elevation={itemElevation}
      style={style.itemContainer}
      onMouseEnter={() => setItemElevation(3)}
      onMouseLeave={() => setItemElevation(1)}
      onClick={() => onClick(classroom.faculty_id)}
    >
      <Box display="flex">
        <Box>
          <Avatar style={style.avatar} alt={classroom.faculty_name}>{avatarInitials(classroom.faculty_name)}</Avatar>
        </Box>
        <Box display="flex" alignItems="center" marginLeft={2}>
          <Typography variant="subtitle1" style={style.detailsTitle}>{classroom.faculty_name}</Typography>
        </Box>
      </Box>
    </Paper>
  )
}

export default FacultyItem